module.exports = __webpack_public_path__ + "static/media/do1.46514b53.png";